var map = {
	"./CQRS/CQRS": 4670,
	"./CQRS/CQRS.js": 4670,
	"./CQS/CQS": 6241,
	"./CQS/CQS.js": 6241,
	"./DDD/DDD": 5855,
	"./DDD/DDD.js": 5855,
	"./DDD/aggregate.png": 322,
	"./MVC/MVC": 9676,
	"./MVC/MVC-purposes.png": 8489,
	"./MVC/MVC.js": 9676,
	"./MVC/MVC.png": 9565,
	"./MVC/domain.png": 9681,
	"./MVC/repository.png": 2044,
	"./MVC/where-to-put-domain-logic.png": 5941,
	"./abstract-factory/abstract-factory": 5096,
	"./abstract-factory/abstract-factory.js": 5096,
	"./abstract-factory/parsing.png": 6523,
	"./adapter/adapter": 5761,
	"./adapter/adapter.js": 5761,
	"./adapter/adapter.png": 8087,
	"./adapter/interfaces.png": 5999,
	"./bridge/bridge": 6018,
	"./bridge/bridge.js": 6018,
	"./bridge/bridge.png": 5980,
	"./builder/builder": 4850,
	"./builder/builder.js": 4850,
	"./builder/user-builder.png": 6026,
	"./chain-of-responsibility/chain-of-responsibility": 3366,
	"./chain-of-responsibility/chain-of-responsibility.jpg": 5862,
	"./chain-of-responsibility/chain-of-responsibility.js": 3366,
	"./chain-of-responsibility/server.jpg": 4754,
	"./command/command": 8234,
	"./command/command.js": 8234,
	"./command/wiki-page.png": 9710,
	"./command/wikipage-class.png": 2371,
	"./composite/ast.png": 6976,
	"./composite/composite": 3097,
	"./composite/composite-interface.png": 1823,
	"./composite/composite.js": 3097,
	"./controlling-side-effects/controlling-side-effects": 9326,
	"./controlling-side-effects/controlling-side-effects.js": 9326,
	"./controlling-side-effects/function-side-effects.png": 647,
	"./controlling-side-effects/function.png": 2751,
	"./controlling-side-effects/function.svg": 9607,
	"./controlling-side-effects/many-functions-global-variables.png": 4302,
	"./creator/creator": 9452,
	"./creator/creator.js": 9452,
	"./decorator/decorator": 3398,
	"./decorator/decorator-polymorphism-theory.png": 1569,
	"./decorator/decorator-polymorphism.png": 3290,
	"./decorator/decorator.js": 3398,
	"./decorator/decorator.png": 2213,
	"./decorator/interface.png": 2764,
	"./decorator/price-interface.png": 3803,
	"./ease-of-change/ease-of-change": 3169,
	"./ease-of-change/ease-of-change.js": 3169,
	"./ease-of-change/paths-later.png": 3566,
	"./ease-of-change/paths-today.png": 6466,
	"./encapsulation/encapsulation": 1567,
	"./encapsulation/encapsulation.js": 1567,
	"./events/event-no-context.png": 5182,
	"./events/event.png": 8711,
	"./events/events": 8796,
	"./events/events.js": 8796,
	"./events/no-event.png": 3454,
	"./events/publish.png": 7991,
	"./events/subscription.png": 3912,
	"./expressive-code/expressive-code": 791,
	"./expressive-code/expressive-code.js": 791,
	"./facade/facade": 6390,
	"./facade/facade.js": 6390,
	"./facade/facade.png": 8782,
	"./factory-method/factory-method": 4297,
	"./factory-method/factory-method.js": 4297,
	"./factory/diagram-application.png": 4323,
	"./factory/factory": 4343,
	"./factory/factory.js": 4343,
	"./hexagonal-architecture/dependencies-inversion.png": 8586,
	"./hexagonal-architecture/hexagonal-architecture": 1939,
	"./hexagonal-architecture/hexagonal-architecture.js": 1939,
	"./hexagonal-architecture/technical-domain.png": 6784,
	"./high-cohesion/2-concerns-in-class.png": 6307,
	"./high-cohesion/cohesive-classes.png": 9820,
	"./high-cohesion/concerns-coupling.png": 9167,
	"./high-cohesion/conversation-support-chat.png": 2469,
	"./high-cohesion/conversation.png": 5632,
	"./high-cohesion/coupling-report-messages.png": 3877,
	"./high-cohesion/coupling-title-support-topic.png": 5220,
	"./high-cohesion/coupling-with-other-components.png": 9514,
	"./high-cohesion/high-cohesion": 7841,
	"./high-cohesion/high-cohesion.js": 7841,
	"./high-cohesion/report-decoupling.png": 5505,
	"./high-cohesion/separate-support-conversation.png": 5766,
	"./indirection/indirection": 7282,
	"./indirection/indirection.js": 7282,
	"./indirection/indirection.png": 672,
	"./information-expert/information-expert": 5709,
	"./information-expert/information-expert.js": 5709,
	"./information-expert/sequence-1.png": 1287,
	"./information-expert/sequence-2.png": 4983,
	"./interpreter/interpreter": 2455,
	"./interpreter/interpreter.js": 2455,
	"./iterator/collection.png": 4604,
	"./iterator/iterator": 9548,
	"./iterator/iterator.js": 9548,
	"./iterator/iterator.png": 9952,
	"./levels-of-abstraction/call-stack-levels-of-abstraction.png": 1667,
	"./levels-of-abstraction/call-stack-what-how.png": 4938,
	"./levels-of-abstraction/call-stack.png": 3090,
	"./levels-of-abstraction/levels-of-abstraction": 6630,
	"./levels-of-abstraction/levels-of-abstraction.js": 6630,
	"./levels-of-abstraction/snippet-abstraction-fix.png": 1677,
	"./levels-of-abstraction/snippet-abstractions.png": 5235,
	"./low-coupling/low-coupling": 4648,
	"./low-coupling/low-coupling.js": 4648,
	"./mediator/mediator": 8155,
	"./mediator/mediator.js": 8155,
	"./mediator/mediator.png": 8316,
	"./memento/memento": 6871,
	"./memento/memento.js": 6871,
	"./memento/memento.png": 9682,
	"./observer/click-button.png": 9556,
	"./observer/observer": 7119,
	"./observer/observer.js": 7119,
	"./polymorphism/interface.png": 2731,
	"./polymorphism/polymorphism": 2476,
	"./polymorphism/polymorphism.js": 2476,
	"./polymorphism/polymorphism.png": 8961,
	"./polymorphism/price-function.png": 2712,
	"./protected-variation/a-calls-b.png": 7922,
	"./protected-variation/anti-corruption-layer.png": 264,
	"./protected-variation/events.png": 9621,
	"./protected-variation/indirection.png": 1320,
	"./protected-variation/inversion-of-dependencies.png": 7742,
	"./protected-variation/protected-variation": 4161,
	"./protected-variation/protected-variation.js": 4161,
	"./prototype/prototype": 8849,
	"./prototype/prototype.js": 8849,
	"./prototype/prototype.png": 9961,
	"./proxy/proxy": 906,
	"./proxy/proxy.js": 906,
	"./proxy/proxy.png": 2915,
	"./pure-fabrication/algo-doctor-separate.png": 4033,
	"./pure-fabrication/doctor-with-algo.png": 8075,
	"./pure-fabrication/pure-fabrication": 8213,
	"./pure-fabrication/pure-fabrication.js": 8213,
	"./state/state": 7773,
	"./state/state-machine.png": 4984,
	"./state/state.js": 7773,
	"./strategy/strategy": 9366,
	"./strategy/strategy.js": 9366,
	"./template-method/template-method": 9299,
	"./template-method/template-method.js": 9299,
	"./visitor/operations-in-dividends.png": 8806,
	"./visitor/visitor": 1804,
	"./visitor/visitor.js": 1804,
	"./visitor/visitor.png": 2375,
	"./world-of-software-design/cropped-river.png": 6959,
	"./world-of-software-design/hexagonal-to-ease-of-change.png": 9346,
	"./world-of-software-design/hierarchy-top.png": 6618,
	"./world-of-software-design/hierarchy.png": 2306,
	"./world-of-software-design/world-of-software-design": 9829,
	"./world-of-software-design/world-of-software-design.js": 9829
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4838;